require('/ui/components/menu/menu.module.scss.module.css');

export const secondaryText = "_secondary-text_qqoro_1";
export const smallViewportSupport = "_small-viewport-support_qqoro_1";
export const itemDisabled = "_item-disabled_qqoro_1";
export const buttonAction = "_button-action_qqoro_1";
export const linkAction = "_link-action_qqoro_1";
export const parentAction = "_parent-action_qqoro_1";
export const itemDestructive = "_item-destructive_qqoro_1";
export const cascadeArrow = "_cascade-arrow_qqoro_1";
export const groupSeparated = "_group-separated_qqoro_1";
export const groupTitle = "_group-title_qqoro_1";
